import { TemplateConfig } from '../core/config.scorecard.model';
import { ScorecardGridOptions } from '../core/scorecard-grid-options.model';
import { WidgetType } from '../core/template-definition.model';

export function getLogoUrlFromTemplateConfig(
    templateConfig: TemplateConfig,
): string | null {
    try {
        if (templateConfig?.widgets) {
            const scorecardWidget = templateConfig.widgets.find(
                (w) => w.widgetType === WidgetType.SCORECARD_GRID,
            );

            if (scorecardWidget != null) {
                const logoUrl = (
                    scorecardWidget.options as ScorecardGridOptions
                )?.logoUrl;
                return logoUrl?.trim().length > 0 ? logoUrl : null;
            }
        }
    } catch (err) {
        console.error('Error retrieving logo URL from widget config:', err);
    }
    return null;
}
